import { useId } from 'react'

type LoadingSpinnerProps = {
  size?: number
  className?: string
  label?: string
}

function classNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(' ')
}

export function LoadingSpinner({
                                 size = 24,
                                 className,
                                 label = 'Loading',
                               }: LoadingSpinnerProps) {
  const maskId = useId()
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="status"
      aria-label={label}
      className={classNames('animate-spin text-indigo-500 place-self-center', className)}
    >
      <circle cx="24" cy="24" r="22" stroke="currentColor" strokeOpacity="0.2" strokeWidth="4" />
      
      <mask id={maskId} fill="white">
        <path d="M48 24C48 29.0683 46.3955 34.0065 43.4164 38.1068C40.4373 42.2072 36.2366 45.2592 31.4164 46.8254L30.197 43.0725C34.2247 41.7638 37.7348 39.2136 40.224 35.7874C42.7133 32.3613 44.054 28.235 44.054 24H48Z" />
      </mask>
      
      <path
        d="M48 24C48 29.0683 46.3955 34.0065 43.4164 38.1068C40.4373 42.2072 36.2366 45.2592 31.4164 46.8254L30.197 43.0725C34.2247 41.7638 37.7348 39.2136 40.224 35.7874C42.7133 32.3613 44.054 28.235 44.054 24H48Z"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinejoin="round"
        mask={`url(#${maskId})`}
      />
    </svg>
  )
}
